<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Bodegas</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table ref="bodegas" @crear="crear" :path="path" @editar="editar" @eliminar="eliminar" :columns="[
          {
            display: 'Código',
            value: 'codigo',
          },
          {
            display: 'Cód. Sucursal',
            value: 'codigo_sucursal',
          },
          {
            display: 'Descripción',
            value: 'descripcion',
          },
          {
            display: 'Creador',
            value: 'creador.nombre',
          },
          {
            display: 'Creación',
            value: 'created_at',
          },
          {
            display: 'Modificador',
            value: 'modificador.nombre',
          },
          {
            display: 'Modificación',
            value: 'updated_at',
          }
        ]"></k-table>
      </div>
    </div>
    <modal name="bodega" scrollable resizable reset adaptive height="auto" width="60%">
      <bodega @cancelar="cancelar" @saved="savedBodega" ref="bodega" v-model="selectedBodega"></bodega>
    </modal>
  </div>
</template>

<script>
import Bodega from "./Bodega.vue";
export default {
  components: {
    Bodega,
  },
  data: function () {
    return {
      path: url + "/inventario/bodegas",
      selectedBodega: null,
    };
  },
  methods: {
    cancelar: function () {
      this.$modal.hide("bodega");
    },
    savedBodega: function () {
      this.$modal.hide("bodega");
      this.$refs.bodegas.loadRows();
    },
    crear: function () {
      this.selectedBodega = {
        estado: "N",
        codigo: "",
        descripcion: "",
        id: "",
        _method: undefined,
        codigo_sucursal: "",
        valor_caja_inicial: ''
      };
      this.$modal.show("bodega");
    },
    editar: function (bodega) {
      this.selectedBodega = {
        codigo: bodega.codigo,
        descripcion: bodega.descripcion,
        estado: bodega.estado,
        id: bodega.id,
        _method: "PUT",
        codigo_sucursal: bodega.codigo_sucursal,
        valor_caja_inicial: bodega.valor_caja_inicial
      };
      this.$modal.show("bodega");
    },
    eliminar: function (bodega) {
      swal({
        title:
          "¿Deseas " +
          (bodega.estado === "A" ? "inactivar" : "re-activar") +
          " la bodega?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/inventario/bodegas/" + bodega.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "La bodega ha sido " +
                (bodega.estado === "A" ? "inactivada" : "re-activada") +
                ".",
                "Realizado",
                "success"
              );
              this.$refs.bodegas.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/Bodegas.vue